import { ApiRequestFilters } from '../../../types/api-request-filters';

/**
 * Vehicle makes filters
 */
export class VehicleMakesFilters extends ApiRequestFilters {}
